// استيراد دوال React لإدارة الحالات والمراجع والتأثيرات الجانبية
import { useEffect, useRef, useState } from "react";
// استيراد مكون Form من React Bootstrap
import { Form } from "react-bootstrap";
// استيراد أيقونة الرفع من Font Awesome
import { faUpload } from "@fortawesome/free-solid-svg-icons";
// استيراد مكون عرض الأيقونات
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// استيراد كائن Axios المهيأ
import { Axios } from "../../../API/Axios";
// استيراد رابط API الخاص بالتصنيفات
import { Cat } from "../../../API/Api";
// استيراد مكون التحميل
import Loading from "../../../components/Loading/Loding";
// استيراد سياق اللغة
import { useLanguage } from "../../../Context/LanguageContext";
// استيراد ملف الأنماط
import "../../../components/Dashboard/FormPage.css";

// المكون الرئيسي لإضافة تصنيف جديد
export default function AddCategory ()
{
    // استيراد دالة الترجمة من سياق اللغة
    const { t } = useLanguage();
    // حالة لتخزين بيانات النموذج (العنوان والصورة)
    const [ formData, setFormData ] = useState( { title: "", image: "" } );
    // حالة التحميل
    const [ loading, setLoading ] = useState( false );
    // مرجع لتركيز المؤشر على حقل العنوان
    const focus = useRef();
    // مرجع لحقل رفع الصورة
    const fileInput = useRef();

    // تأثير جانبي لتركيز المؤشر على حقل العنوان عند تحميل المكون
    useEffect( () =>
    {
        focus.current.focus(); // تركيز المؤشر على حقل العنوان
    }, [] ); // يتم التنفيذ مرة واحدة عند تحميل المكون

    // دالة معالجة تغيير المدخلات
    const handleChange = ( e ) =>
    {
        // استخراج اسم الحقل والقيمة والملفات من الحدث
        const { name, value, files } = e.target;
        // تحديث بيانات النموذج
        setFormData( {
            ...formData,
            // إذا كان الحقل هو الصورة ويوجد ملفات، استخدام الملف الأول، وإلا استخدام القيمة النصية
            [ name ]: name === "image" && files.length > 0 ? files[ 0 ] : value,
        } );
    };

    // دالة غير متزامنة لمعالجة تقديم النموذج (إضافة تصنيف جديد)
    async function handleSubmit ( e )
    {
        // منع إعادة تحميل الصفحة
        e.preventDefault();
        // تفعيل حالة التحميل
        setLoading( true );
        // إنشاء كائن FormData لإرسال الملفات والنصوص
        const form = new FormData();
        // إضافة العنوان إلى البيانات
        form.append( "title", formData.title );
        // إضافة الصورة إلى البيانات
        form.append( "image", formData.image );

        try
        {
            // إرسال طلب POST لإضافة تصنيف جديد مع FormData
            await Axios.post( `${ Cat }/add`, form );
            // إعادة توجيه المستخدم إلى صفحة قائمة التصنيفات بعد النجاح
            window.location.pathname = "/dashboard/categories";
        } catch ( error )
        {
            // طباعة تفاصيل الخطأ في وحدة التحكم للمساعدة في التصحيح
            console.error( "Error response:", error.response );
            // إلغاء حالة التحميل في حالة الخطأ
            setLoading( false );
        }
    }

    // التحقق من صحة البيانات قبل تمكين زر الإرسال
    const canSubmit = formData.title.length >= 2 && !!formData.image; // العنوان أكبر من حرفين وتم اختيار صورة

    // عرض واجهة إضافة تصنيف جديد
    return (
        <>
            {/* عرض مكون التحميل إذا كانت الحالة true */ }
            { loading && <Loading /> }
            {/* حاوية النموذج */ }
            <div className="form-page-wrap">
                {/* نموذج إضافة التصنيف */ }
                <Form className="form-page-card" onSubmit={ handleSubmit }>
                    {/* عنوان النموذج المترجم */ }
                    <h3 className="form-page-title">{ t( 'categories.addTitle' ) }</h3>

                    {/* حقل عنوان التصنيف */ }
                    <Form.Group className="mb-3" controlId="categoryTitle">
                        <Form.Label>{ t( 'categories.titleLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.title } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="title" // اسم الحقل
                            type="text" // نوع الإدخال نص
                            placeholder={ t( 'categories.titlePlaceholder' ) } // النص الافتراضي المترجم
                            ref={ focus } // ربط المرجع للتركيز
                            required // الحقل مطلوب
                        />
                    </Form.Group>

                    {/* حقل صورة التصنيف */ }
                    <Form.Group className="mb-3" controlId="categoryImage">
                        <Form.Label>{ t( 'categories.imageLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        {/* منطقة رفع الصورة */ }
                        <div
                            className="upload-dropzone is-active" // كلاس المنطقة النشطة
                            onClick={ () => fileInput.current.click() } // فتح نافذة اختيار الملف عند النقر
                        >
                            <span className="upload-dropzone-icon">
                                <FontAwesomeIcon icon={ faUpload } /> {/* أيقونة الرفع */ }
                            </span>
                            {/* عرض اسم الملف إذا تم اختياره، وإلا عرض نص الرفع المترجم */ }
                            <p>{ formData.image ? formData.image.name : t( 'products.uploadHere' ) }</p>
                        </div>
                        {/* حقل إدخال الملف المخفي */ }
                        <Form.Control
                            ref={ fileInput } // ربط المرجع
                            onChange={ handleChange } // دالة التغيير
                            name="image" // اسم الحقل
                            type="file" // نوع الإدخال ملف
                            required // الحقل مطلوب
                            className="d-none" // إخفاء الحقل
                        />
                    </Form.Group>

                    {/* زر الإرسال - يتم تعطيله إذا كانت البيانات غير صالحة */ }
                    <button disabled={ !canSubmit } className="form-page-submit" type="submit">
                        { t( 'categories.save' ) } {/* نص الزر المترجم */ }
                    </button>
                </Form>
            </div>
        </>
    );
}